
import {
  Button,
} from 'ant-design-vue';
import {
  defineComponent, SetupContext,
} from 'vue';

export default defineComponent({
  props: {
    type: {
      type: String,
      defalut: () => null,
    },
    size: {
      type: String,
      defalut: () => null,
    },
    shape: {
      type: String,
      defalut: () => null,
    },
    htmlType: {
      type: String,
      defalut: () => null,
    },
    key: {
      type: String,
      defalut: () => 'submit',
    },
    loading: {
      type: Boolean,
      defalut: () => false,
    },
    disabled: {
      type: Boolean,
      defalut: () => false,
    },
    // 将按钮宽度调整为其父宽度的选项
    block: {
      type: Boolean,
      defalut: () => false,
    },
    // 按钮背景透明
    ghost: {
      type: Boolean,
      defalut: () => false,
    },
    // 设置危险按钮
    danger: {
      type: Boolean,
      defalut: () => false,
    },
  },
  components: {
    aButton: Button,
  },
  emits: ['click'],
  setup(props, context: SetupContext) {
    const fn = (e: Event) => {
      Promise.resolve(context.emit('click', e)).finally();
    };

    return {
      props,
      ...context,
      fn,
    };
  },
});
